import axiosInstance from './axios';

export interface ProductionPayload {
  venueId: string;
  globalProductId: number;
  productionCenterId: string;
  quantity: number;
  createdByUserId?: string;
}

export const storeProduction = async (payload: ProductionPayload): Promise<{ result?: boolean }> => {
  try {
    const { data } = await axiosInstance({
      method: 'post',
      url: 'stock/productions',
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
